import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

export const LinksContainer = styled.div(
  ({ theme }) => `
    padding-left: 2rem;
    padding-top: ${theme.spacing.husky};

    ${MEDIA_QUERIES(theme).mediumSmall} {
      display: flex;
      flex-wrap: wrap;
    }

    ${MEDIA_QUERIES(theme).medium} {
      padding-left: ${theme.spacing.husky};
      padding-top: 6rem;
      width: 64%;
    }

    ${MEDIA_QUERIES(theme).large} {
      justify-content: space-between;
      margin: 0 auto;
      padding: 8.8rem 0 0 0;
      width: ${theme.breakpoints.large}px;
    }
  `
)

export const Column = styled.div(
  ({ theme }) => `
    margin-top: 5.6rem;

    &:first-child {
      margin-top: 0;
    }

    ${MEDIA_QUERIES(theme).mediumSmall} {
      flex-basis: 50%;
      margin: 0;
      min-width: 50%;
      padding-bottom: 6rem;
    }

    ${MEDIA_QUERIES(theme).medium} {
      flex-basis: auto;
    }

    ${MEDIA_QUERIES(theme).large} {
      margin: 0 auto;
      min-width: 0;
    }
`
)

export const ColumnTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
  color: #c5c6cb;
  letter-spacing: 2px;
  margin: 0;
  text-transform: uppercase;
`

export const ColumnList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const ColumnItem = styled.li`
  align-items: center;
  display: flex;
  margin-top: 1.5rem;

  &:first-child {
    margin-top: 2.5rem;
  }
`

export const ColumnLink = styled.a(
  ({ theme }) => `
  color: ${theme.colors.white};
  float: none;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 2rem;
  padding: 0;
  position: relative;
  text-decoration: none;
  transition: color 200ms linear;

  &:active, &:focus {
    color: ${theme.colors.green.light2};
  }

  &:hover {
    color: ${theme.colors.green.light2};
  }
`
)

export const ColumnSpan = styled(ColumnLink).attrs({ as: 'span' })``
